import { Children, cloneElement } from "react";
import { Button, Divider, Space } from "antd";
import cx from "classnames";
import * as styles from "./buttonGroup.module.scss";

const ButtonGroupButton = ({
  value,
  children,
  selected,
  onClick,
  size,
  icon,
}) => {
  return (
    <Button
      className={styles.buttonGroup__button}
      type={selected ? "primary" : "text"}
      onClick={() => onClick(value)}
      size={size}
      icon={icon}
    >
      {children}
    </Button>
  );
};

export const ButtonGroup = ({
  children,
  value,
  onChange,
  size = "small",
  divided = false,
  disabled = false,
}) => {
  const handleChange = (newValue) => {
    if (!disabled && newValue !== value) {
      onChange?.(newValue);
    }
  };

  return (
    <Space
      className={cx(styles.buttonGroup, {
        [styles.buttonGroup_small]: size === "small",
        [styles.buttonGroup_middle]: size === "middle",
        [styles.buttonGroup_large]: size === "large",
        [styles.buttonGroup_disabled]: disabled,
      })}
      size={0}
      split={divided && <Divider style={{ margin: 0 }} type="vertical" />}
    >
      {Children.map(children, (child) => {
        if (child?.type === ButtonGroupButton) {
          return cloneElement(child, {
            selected: value === child.props.value,
            onClick: handleChange,
            size,
          });
        }
        return child;
      })}
    </Space>
  );
};

ButtonGroup.Button = ButtonGroupButton;
